<script lang="ts" setup>
defineProps<{
  id: number
  title: string
  summary: string
  cover: string
  tags?: string[]
  likes: number
  views: number
  comments: number
  duration: number
  userId: number
  username: string
  userAvatar: string
  badges: number[]
  userAuth?: User.Auth
  createdAt: number
}>()
</script>

<template>
  <div class="m-video-card">
    <div class="m-video-card__header">
      <m-user-info
        :id="userId"
        :name="username"
        :avatar="userAvatar"
        :badges="badges"
        :auth="userAuth"
        size="xs"
      >
        <div>{{ pipe.date(createdAt) }}</div>
      </m-user-info>
    </div>
    <m-link
      :resource-id="id"
      :resource-type="1"
      :title="title"
      class="m-video-card__body"
    >
      <div class="m-video-card__cover">
        <m-img :src="cover" alt="m-video-card__cover" />
        <div class="m-video-card__duration">
          {{ pipe.time(duration, true) }}
        </div>
      </div>
      <div class="m-video-card__info">
        <div class="m-video-card__title">
          <h3 class="m-video-card__h3">{{ title }}</h3>
        </div>
        <div class="m-video-card__content">{{ summary }}</div>
      </div>
    </m-link>
    <div class="m-video-card__footer">
      <div class="m-video-card__tags">
        <m-topics :topics="tags" />
      </div>
      <div class="m-video-card__data">
        <div class="m-video-card__data-item">
          <span>{{ pipe.num(views) }}播放</span>
        </div>
        <div class="m-video-card__data-item">
          <span>{{ pipe.num(comments) }}评论</span>
        </div>
        <div class="m-video-card__data-item">
          <span>{{ pipe.num(likes) }}赞</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-video-card {
  &__header {
    margin-bottom: 16px;
  }

  &__title {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
  }

  &__body {
    display: flex;
    background-color: #fff;
    border-radius: 5px;
    overflow: hidden;
  }

  &__info {
    flex: 1;
    width: 0;
    padding: 12px 16px 10px;
  }

  &__h3 {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  &__content {
    line-height: 18px;
    margin-top: 8px;
    color: var(--color-gray-600);
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  &__cover {
    width: 208px;
    height: 115px;
    border-right: 1px solid var(--color-gray-300);
    position: relative;
  }

  &__duration {
    position: absolute;
    bottom: 8px;
    right: 8px;
    padding: 0 4px;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 2px;
    color: #fff;
    font-size: 12px;
    line-height: 16px;
  }

  &__data {
    margin-top: 5px;
    display: flex;
    align-items: center;

    &-item {
      margin-right: 10px;
      display: flex;
      align-items: center;

      > span {
        padding-right: 8px;
        font-size: 12px;
        color: var(--color-gray-500);
      }
    }
  }
}
</style>
